import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Grid,
  CircularProgress,
  Tooltip,
  IconButton,
  Paper,
} from "@mui/material";
import { ContentCopy, Refresh, ArrowRightAlt } from "@mui/icons-material";
import { useTheme } from "@mui/system";
import { fetchNpmToken } from "../utils/api";
import Loader from "../Components/Loader";
import { useGlobal } from "../Context/globalContext";

const REACT_APP_PUBLISH_REGISTRY = "https://dev-registry.hyperdart.com";

const TokenDetails = () => {
  const { developerInfo, refreshDeveloperInfo } = useGlobal();
  const [token, setToken] = useState("");
  const [copiedItem, setCopiedItem] = useState("");
  const [loadingToken, setLoadingToken] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    if (developerInfo?.token) {
      setToken(developerInfo.token);
    } else {
      getNpmTokenFromServer();
    }
  }, [developerInfo?.token]);

  const getNpmTokenFromServer = () => {
    setLoadingToken(true);
    fetchNpmToken()
      .then((npmToken) => {
        refreshDeveloperInfo();
        setToken(npmToken);
      })
      .catch(console.error)
      .finally(() => setLoadingToken(false));
  };

  const copyToClipboard = (text, id) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedItem(id);
      setTimeout(() => setCopiedItem(""), 2000);
    });
  };

  const removeProtocolFromUrl = (url) =>
    url?.replace(/^(https?:\/\/)/, "") || "";

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} md={10} lg={10}>
        <Paper
          elevation={4}
          sx={{
            p: 4,
            borderRadius: "12px",
            mt: 1,
            bgcolor: "#fff",
            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          }}
        >
          {/* Heading */}
          <Typography
            variant="h6"
            sx={{
              borderBottom: (theme) => `2px solid ${theme.palette.primary.main}`,
              pb: 1,
              color: theme => theme.palette.primary.main,
              fontWeight:600
              
            }}
          >
            Publishing Setup — Developer Token Instructions
          </Typography>

          {/* STEP BLOCK */}
          <Box sx={{ mt: 2 }}>
            <Box display="flex" alignItems="center" gap={1}>
              <ArrowRightAlt color="primary" />
            <Typography variant="subtitle1" sx={{  color: theme => theme.palette.primary.main , fontWeight:600}}>
               Set Your Token in npm Config
            </Typography>
            </Box>

            <CodeBlock
              loading={loadingToken}
              token={token}
              content={`npm config set //${removeProtocolFromUrl(
                REACT_APP_PUBLISH_REGISTRY
              )}/:_authToken=${token}`}
              onCopy={(text) => copyToClipboard(text, "copy1")}
              copied={copiedItem === "copy1"}
              copyId="copy1"
            />
          </Box>

          {/* Publish */}
          <Box sx={{ mt: 1 }}>
            <Box display="flex" alignItems="center" gap={1}>
              <ArrowRightAlt color="primary" />
            <Typography variant="subtitle1" sx={{ color: theme => theme.palette.primary.main , fontWeight: 600 }}>
              To Publish Package to hyperDart Registry
            </Typography>
            </Box>

            <CodeBlock
              content={`npm publish --registry ${REACT_APP_PUBLISH_REGISTRY}/`}
              onCopy={(text) => copyToClipboard(text, "copy2")}
              copied={copiedItem === "copy2"}
              copyId="copy2"
            />
          </Box>

          {/* Unpublish */}
          <Box sx={{ mt: 1 }}>
            <Box display="flex" alignItems="center" gap={1}>
              <ArrowRightAlt color="primary" />
            <Typography variant="subtitle1" sx={{ color: theme => theme.palette.primary.main, fontWeight: 600 }}>
              To Unpublish Entire Package
            </Typography>
            </Box>

            <CodeBlock
              content={`npm unpublish --registry ${REACT_APP_PUBLISH_REGISTRY}/ componentName --force`}
              onCopy={(text) => copyToClipboard(text, "copy3")}
              copied={copiedItem === "copy3"}
              copyId="copy3"
            />
          </Box>

          {/* Unpublish single version */}
          <Box sx={{ mt: 1 }}>
            <Box display="flex" alignItems="center" gap={1}>
              <ArrowRightAlt color="primary" />
            <Typography variant="subtitle1" sx={{ color: theme => theme.palette.primary.main, fontWeight: 600 }}>
              To Unpublish Specific Version
            </Typography>
            </Box>

            <CodeBlock
              content={`npm unpublish --registry ${REACT_APP_PUBLISH_REGISTRY}/ componentName@version --force`}
              onCopy={(text) => copyToClipboard(text, "copy4")}
              copied={copiedItem === "copy4"}
              copyId="copy4"
            />
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};


const CodeBlock = ({ content, onCopy, copied, loading, token }) => {
  return (
    <Box
      sx={{
        mt: 1,
        p: 2.5,
        bgcolor: "#f8f8f8",
        borderRadius: "8px",
        border: "1px solid #e0e0e0",
        position: "relative",
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          wordBreak: "break-word",
          color: "#333",
          
        }}
      >
        {loading ? <Loader /> : content}
      </Typography>

      <Box sx={{ position: "absolute", top: 6, right: 6, display: "flex" }}>
        <Tooltip title="Copy" arrow>
          <IconButton size="small" onClick={() => onCopy(content)}>
            <ContentCopy fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      {copied && (
        <Typography sx={{ mt: 1, fontSize: "13px", color: theme => theme.palette.primary.main }}>
          Copied!
        </Typography>
      )}
    </Box>
  );
};

export default TokenDetails;
